var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcesss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.344 10.344L13.736 13.736M18.264 18.264L21.656 21.656M21.656 10.344L18.264 13.736L21.088 10.912M10.344 21.656L13.736 18.264M24 16C24 20.4184 20.4182 24 16 24C11.5818 24 8 20.4184 8 16C8 11.5816 11.5818 8 16 8C20.4182 8 24 11.5816 24 16ZM19.2 16C19.2 17.7672 17.7673 19.2 16 19.2C14.2327 19.2 12.8 17.7672 12.8 16C12.8 14.2328 14.2327 12.8 16 12.8C17.7673 12.8 19.2 14.2328 19.2 16Z",
    stroke: "#505780",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesss);
export default __webpack_public_path__ + "static/media/Processs.fadff0f2544baeed74c003c7a2922117.svg";
export { ForwardRef as ReactComponent };